(function () {
    'use strict';
  
    if (window.__fauxVariantSwapInit) return;
    window.__fauxVariantSwapInit = true;
  
    // Intercept clicks on faux variant thumbnails to save scroll, then allow real navigation
    document.addEventListener('click', function (e) {
      if (!e.target || typeof e.target.closest !== 'function') return;
      var link = e.target.closest('.faux-variants .associated-products-list a[href]');
      if (!link) return;
  
      // Save scroll position for destination path, then let browser navigate normally
      var dest = link.getAttribute('href') || '';
      var destPath = dest.split('?')[0];
      try {
        console.log('[FauxNav] Faux variant click → saving scroll', { path: destPath, y: window.scrollY || 0 });
        sessionStorage.setItem('fauxScroll:' + destPath, String(window.scrollY || 0));
      } catch (err) {
        console.warn('[FauxNav] Failed to save scroll to sessionStorage', err);
      }
      // Stop propagation to reduce noise from other click handlers; allow default navigation
      try {
        e.stopPropagation();
        console.log('[FauxNav] Stopped event propagation for faux-variant click');
      } catch (_) {}
      // Do not preventDefault — real navigation proceeds
    }, true);
  })();